import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiZap, FiArrowRight, FiGift } = FiIcons;

const PopupAd = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show after 4 seconds, only once per session
    const shown = sessionStorage.getItem('popupShown');
    if (!shown) {
      const timer = setTimeout(() => {
        setVisible(true);
        sessionStorage.setItem('popupShown', 'true');
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setVisible(false)}
        >
          <motion.div
            initial={{ scale: 0.8, y: 40, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.8, y: 40, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 200, damping: 20 }}
            onClick={e => e.stopPropagation()}
            className="relative w-full max-w-sm rounded-3xl overflow-hidden shadow-2xl"
          >
            {/* Background */}
            <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-blue-900/40 to-gray-900" />
            <div className="absolute inset-0 opacity-10"
              style={{
                backgroundImage: 'radial-gradient(circle, rgba(0,102,255,0.4) 1px, transparent 1px)',
                backgroundSize: '20px 20px'
              }}
            />

            {/* Close button */}
            <button
              onClick={() => setVisible(false)}
              className="absolute top-3 right-3 z-10 w-8 h-8 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors"
            >
              <SafeIcon icon={FiX} className="text-sm" />
            </button>

            {/* Content */}
            <div className="relative p-7 text-center">
              {/* Icon */}
              <motion.div
                animate={{ rotate: [0, -10, 10, -10, 0], scale: [1, 1.1, 1] }}
                transition={{ duration: 1, repeat: Infinity, repeatDelay: 2 }}
                className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg shadow-yellow-500/30"
              >
                <SafeIcon icon={FiGift} className="text-white text-3xl" />
              </motion.div>

              {/* Badge */}
              <div className="inline-flex items-center space-x-1 bg-blue-600/30 border border-blue-500/40 rounded-full px-3 py-1 text-blue-300 text-xs mb-3">
                <SafeIcon icon={FiZap} className="text-xs" />
                <span>Special Offer</span>
              </div>

              <h2 className="text-2xl font-black text-white mb-2 leading-tight">
                🎉 Weekly Lucky Draw!
              </h2>
              <p className="text-gray-300 text-sm mb-4 leading-relaxed">
                Enter our weekly lucky draw and win exciting prizes — Earphones, Cables, Free Service Visit & more!
              </p>

              {/* Prizes */}
              <div className="grid grid-cols-2 gap-2 mb-5">
                {['🎧 Earphones', '🔌 Data Cables', '🔧 Free Service', '💰 10% Off'].map((prize, i) => (
                  <div key={i} className="bg-white/5 border border-white/10 rounded-xl px-3 py-2 text-white text-xs font-medium">
                    {prize}
                  </div>
                ))}
              </div>

              {/* CTA */}
              <Link
                to="/lucky-draw"
                onClick={() => setVisible(false)}
                className="w-full flex items-center justify-center space-x-2 bg-gradient-to-r from-blue-600 to-cyan-500 text-white font-bold py-3 rounded-2xl hover:from-blue-700 hover:to-cyan-600 transition-all duration-300 shadow-lg shadow-blue-500/30"
              >
                <span>Enter Lucky Draw</span>
                <SafeIcon icon={FiArrowRight} className="text-sm" />
              </Link>

              <button
                onClick={() => setVisible(false)}
                className="mt-3 text-gray-500 text-xs hover:text-gray-400 transition-colors"
              >
                Maybe later
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PopupAd;